// extracted by mini-css-extract-plugin
export default {"threeDModelComponent":"RotatingModelViewer_threeDModelComponent__zkaaF","loadingContainer":"RotatingModelViewer_loadingContainer__2gaB3"};